import { DataSourceTableSelectItem } from 'src/constants/dataSourceTable';

export const enum QueryStatus {
  NO_QUERY = 'NO_QUERY',
  QUERYING = 'QUERYING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  EXISTING_ROWS = 'EXISTING_ROWS',
}

export const enum ProjectVirtualGraphQueryType {
  NONE = 'NONE',
  TABLE = 'TABLE',
  CUSTOM = 'CUSTOM',
}

type ProjectVirtualGraphNoQuery = {
  type: ProjectVirtualGraphQueryType.NONE;
  tableItem?: never;
  customText?: never;
};

type ProjectVirtualGraphTableQuery = {
  type: ProjectVirtualGraphQueryType.TABLE;
  tableItem: DataSourceTableSelectItem;
  customText?: never;
};

type ProjectVirtualGraphCustomQuery = {
  type: ProjectVirtualGraphQueryType.CUSTOM;
  tableItem?: never;
  customText: string;
};

export type ProjectVirtualGraphQuery =
  | ProjectVirtualGraphNoQuery
  | ProjectVirtualGraphTableQuery
  | ProjectVirtualGraphCustomQuery;
